const border = {
  light: 'border border-gray-200 bg-gray-0 p-4 rounded-xl',
  dark: 'border border-gray-400 bg-gray-0 p-4 rounded-xl'
}

const table = {
  table: "!rounded-lg overflow-hidden",
  thead:
    "!bg-gray-50 !rounded-lg text-gray-500 ring-1 ring-inset ring-gray-500/10 shadow-sm",
  th: "rounded-[6px] !h-11 text-gray-700",
  td: "text-gray-700 text-sm !py-3"
}

const input = {
  bordered: {
    input:
      "rounded-lg !h-11 border border-gray-300 bg-white hover:border-gray-500 focus:border-gray-600 focus-within:!border-gray-600",
  },
  filled: {
    input:
      "rounded-lg !h-11 !bg-gray-100 !border !border-transparent focus:!border focus:border-gray-600 focus-within:!border-gray-600",
  },
};

const textarea = {
  bordered: {
    input:
      "rounded-lg border border-gray-300 bg-white hover:border-gray-500 focus:border-gray-600 focus-within:!border-gray-600",
  },
  filled: {
    input:
      "rounded-lg !bg-gray-100 !border !border-transparent focus:!border focus:border-gray-600 focus-within:!border-gray-600",
  },
};

const multiSelect = {
  filled: {
    input: "rounded-lg !min-h-11 !bg-gray-100 !border !border-transparent focus:!border focus:border-gray-600 focus-within:!border-gray-600 !flex !items-center",
    pill: "!rounded-lg !bg-white !text-gray-800 shadow-sm",
  },
}

const badge = {
  light: 'text-gray-700 text-sm bg-[#00000008] px-2.5 py-1 rounded-lg',
  bordered: 'inline-flex max-w-fit items-center rounded-md px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-600/20',
  gray: "inline-flex max-w-fit items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600",
  red: "inline-flex max-w-fit items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700",
  yellow: "inline-flex max-w-fit items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800",
  green: "inline-flex max-w-fit items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700",
  blue: "inline-flex max-w-fit items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700",
  darkblue: "inline-flex max-w-fit items-center rounded-md bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700",
  purple: "inline-flex max-w-fit items-center rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700",
  pink: "inline-flex max-w-fit items-center rounded-md bg-pink-50 px-2 py-1 text-xs font-medium text-pink-700",
}

// 신호등 (칭찬/주시/위급) — 테이블 뱃지와 동일 색상, 상세 헤더용 사이즈
const signal = {
  green: "inline-flex max-w-fit items-center rounded-md bg-green-50 px-3 py-1.5 text-sm font-medium text-green-700",
  yellow: "inline-flex max-w-fit items-center rounded-md bg-yellow-50 px-3 py-1.5 text-sm font-medium text-yellow-800",
  red: "inline-flex max-w-fit items-center rounded-md bg-red-50 px-3 py-1.5 text-sm font-medium text-red-700",
}

const button = {
  bordered: {
    label: "!text-gray-600",
    root: "!border !border-gray-300 !h-10 !bg-transparent hover:!bg-transparent hover:!border-gray-500 active:!border-gray-600",
  },
  dark: {
    label: "!text-white",
    root: "!h-10 !bg-gray-800 hover:!bg-gray-700",
  },
  gray: {
    label: "!text-gray-600",
    root: "!h-10 !bg-gray-100 hover:!bg-gray-200",
  },
  transparent: {
    label: "!text-gray-600",
    root: "!h-10 !bg-transparent hover:!bg-gray-100",
  },
  colored: {
    label: "!text-white",
    root: "!h-10 !bg-blue-500 hover:!bg-blue-600",
  },
  disabled: {
    label: "!text-white",
    root: "!h-10 !bg-gray-400",
  },
};

const layout = {
  mobile: '(max-width: 576px)',
  desktop: '(min-width: 1200px)',
};

const themeVariables = {
  border,
  badge,
  signal,
  button,
  table,
  textarea,
  input,
  multiSelect,
  layout
};

export default themeVariables;